// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Web component for deck renderer toolbar.
 * @author James Reid
 */

// @ts-check

// @@imports-package
import { App } from "../../../app/index.js"
import { MeasurementInput } from "../../elements/index.js"

// @@imports-utils
import { cloneTemplate, fadeElementIn, fadeElementOut } from "../../../utils/index.js"
import { DeckRenderer } from "./Renderer.js"
import { Deck } from "../../../../../package/Deck.js"

// @@body
class Toolbar extends HTMLElement {
    nav = cloneTemplate("deck-editor-toolbar")

    constructor() {
        super()
    }

    open() {
        fadeElementIn(this.nav, { animation: "fade-down-in" })
    }

    close() {
        fadeElementOut(this.nav, { animation: "fade-up-out" })
    }

    get state() {
        return App.instance.state
    }

    get container() {
        return App.instance.container
    }

    get renderer() {
        return /** @type {DeckRenderer} */ (App.instance.state.deck.renderer)
    }

}

class DeckToolbar extends Toolbar {
    constructor() {
        super()
    }

    connectedCallback() {
        this.nav.querySelector("button#unit-switch")
            ?.addEventListener("click", () => {
                document.querySelectorAll("measurement-input")
                    .forEach(input => {
                        /** @type {MeasurementInput} */ (input).switchUnits()
                    })
                this.renderer.flags.metric = !this.renderer.flags.metric

                this.nav.querySelector("button#unit-switch p.smaller")
                    .innerText = this.renderer.flags.metric ? "Imperial" : "Metric"
            })
        this.nav.querySelector("button#refresh-deck-editor")
            ?.addEventListener("click", async () => {
                await this.container.unload()

                this.renderer.stop()

                // this.state.deck.client = new Deck({
                //     vertices: this.state.deck.default.deck.copy().vertices.array,
                //     isClosed: true
                // })
                this.state.deck.client = null

                this.renderer.renderFeatures.types = false
                this.renderer.flags.metric = true

                this.container.rerenderStep()
            })

        this.append(this.nav)
    }

    static get customName() {
        return "deck-toolbar"
    }
}

class ApexToolbar extends Toolbar {
    constructor() {
        super()
    }

    connectedCallback() {
        this.nav.querySelector("button#unit-switch")
            ?.addEventListener("click", () => {
                document.querySelectorAll("measurement-input")
                    .forEach(input => {
                        /** @type {MeasurementInput} */ (input).switchUnits()
                    })
                this.renderer.flags.metric = !this.renderer.flags.metric

                this.nav.querySelector("button#unit-switch p.smaller")
                    .innerText = this.renderer.flags.metric ? "Imperial" : "Metric"
            })
        this.nav.querySelector("button#refresh-deck-editor")
            ?.addEventListener("click", async () => {
                await this.container.unload()

                this.renderer.flags.metric = true

                this.container.rerenderStep()
            })

        this.append(this.nav)
    }

    static get customName() {
        return "apex-toolbar"
    }
}

// @@exports
export { DeckToolbar, ApexToolbar }
